import apiClient from './arkandhaConfig.js';

export default {
    async getProjects() {    
        return await apiClient.get('projects');
    },
};